var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#b17ffa",
    opacity: 1,
    "data-original": "#ffd300",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#843eea",
    d: "m511.153 276.826-92.756-92.756-32.634-.168-72.443-72.442L96.947 273.016l24.983 24.983-7.289 38.236L288.376 509.97c119.319-15.059 213.042-112.245 222.777-233.144z",
    opacity: 1,
    "data-original": "#ffb600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59efd2",
    d: "M295.127 103.242H111.872c-13.401 0-24.265 10.864-24.265 24.265v126.385c0 13.401 10.864 24.265 24.265 24.265h3.39l-.622 58.079 33.746-58.079h146.74c13.401 0 24.265-10.864 24.265-24.265V127.506c0-13.401-10.863-24.264-24.264-24.264z",
    opacity: 1,
    "data-original": "#7a83ea",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19d8b4",
    d: "M295.127 103.242h-91.628v174.914h91.628c13.401 0 24.265-10.864 24.265-24.265V127.506c-.001-13.401-10.864-24.264-24.265-24.264z",
    opacity: 1,
    "data-original": "#4b5be3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcce36",
    d: "M216.873 350.68h183.255c13.401 0 24.265-10.864 24.265-24.265V200.03c0-13.401-10.864-24.265-24.265-24.265H216.873c-13.401 0-24.265 10.864-24.265 24.265v126.385c.001 13.401 10.864 24.265 24.265 24.265z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fba32b",
    d: "M400.128 175.765h-91.627V350.68h55.113l33.746 58.079-.622-58.079h3.39c13.401 0 24.265-10.864 24.265-24.265V200.03c0-13.401-10.864-24.265-24.265-24.265z",
    opacity: 1,
    "data-original": "#e3eaee",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M243.157 252.332h21.781v21.781h-21.781zM297.61 252.332h21.781v21.781H297.61z",
    opacity: 1,
    "data-original": "#5a5a5a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32393f",
    d: "M352.063 252.332h21.781v21.781h-21.781zM308.501 252.332h10.891v21.781h-10.891z",
    opacity: 1,
    "data-original": "#32393f",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.889549bb43916870085d3dbac8cf8a6b.svg";
export { ForwardRef as ReactComponent };